import React from "react";
import { cn } from "../../../../Utils/helper";

const STYLE_MAP = {
  ticket: { bg: "bg-[#08B89D]", text: "text-white" },
  pause: { bg: "bg-[#EF4056]", text: "text-white text-[8px]" },
  bookmark: { bg: "bg-[#EF4056]", text: "text-white" },

  lock: { bg: "bg-[#E9E6E4]", text: "text-[#A0A0A0]" },
  check: { bg: "bg-[#DEEFED]", text: "text-[#08B89D] text-[10px]" },
  ban: { bg: "border-[1.5px] border-[#EF4056]", text: "text-[#EF4056]" },
  help: { bg: "bg-[#253FF6]", text: "text-white" },
  clock: { bg: "bg-[#253FF6]", text: "text-white" },

  full: {
    bg: "bg-[#E9E6E4]",
    text: "text-[#EF4056] font-bold text-center text-[7.5px]",
  },
  banTicket: {
    bg: "bg-[#08B89D]",
    text: "text-white",
  },

  default: { bg: "bg-[#EF4056]", text: "text-gray-400" },
};
const BannedOverlay = () => (
  <>
    <div className="absolute inset-0 rounded-full border-[1.5px] border-[#EF4056] pointer-events-none z-20" />

    <div className="absolute inset-0 flex items-center justify-center pointer-events-none z-20">
      <div className="w-full h-[2px] bg-[#EF4056] -rotate-45" />
    </div>
  </>
);
const StatusIcon = ({
  icon,
  className = "",
  onClick,
  classNameIcon = "font-bold",
  isBanned = false,
  ...props
}) => {
  const style = STYLE_MAP[icon] || STYLE_MAP.default;

  const content =
    icon === "full" ? (
      <span className={cn(`${style.text}  ${style.bg} `)}>FULL</span>
    ) : (
      <span
        className={cn(
          `icon icon-${icon} text-xs ${style.text} `,
          classNameIcon
        )}
      />
    );

  return (
    <div
      className={cn(
        `w-5 h-5 rounded-full flex justify-center items-center ${style.bg} ${className}`,
        isBanned && "relative border-[1.5px] border-[#EF4056] "
      )}
      onClick={onClick}
    >
      {content}

      {isBanned && <BannedOverlay />}
    </div>
  );
};

export default StatusIcon;
